import { QueryCache, QueryClient } from '@tanstack/react-query';

export const apiQueryCache = new QueryCache();

/**
 * The app-wide react-query client. Shared between the main application tree and detached React
 * roots (e.g. CKEditor-rendered Organizer content) via <Root>, so all trees read the same cache.
 */
export const apiQueryClient = new QueryClient({ queryCache: apiQueryCache });
